import React, { useState, useEffect, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { Download, Results } from './components';
import { useLocation } from 'react-router-dom';
import { Page } from 'components';
import { Card, Row, Col, Button } from 'react-bootstrap';
import Header from '../../components/Header/Header';
import Reload from '../../components/Reload/Reload';

//import XLSX from 'xlsx';

import * as XLSX from 'xlsx';

import ApiGSenha from 'services/ApiGSenha';
import ApiMServer from 'services/ApiMServer';
import ApiGServer from 'services/ApiGServer';

const Relatorio = () => {
  const [equipments, setEquipments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [reportTitle, setReportTitle] = useState('Relatório de Ativação');
  const location = useLocation();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      // Obtém dados do location state
      const routeState = location.state;

      // Verifica se existem dados no state
      if (!routeState || !routeState.equipFilter || !routeState.equipmentsList) {
        setLoading(false);
        return; // Não prossegue se não houver dados
      }

      const filter = routeState.equipFilter;
      const globalEquipments = routeState.equipmentsList;
      const companyName = routeState.companyName || "";

      setReportTitle(`Relatório de Ativação - ${companyName}`);

      try {
        // Busca os dados de desbloqueio
        const unlockResponse = await ApiGSenha.post(`/log/unlockfilter`, { "filter": filter });

        // Processa os dados de equipamentos
        let equipmentsData = unlockResponse.data;

        // Enriquece dados com informações do equipamento global
        equipmentsData = equipmentsData.map(equip => {
          // Encontra dados adicionais do equipamento na lista global
          const matchedEquip = globalEquipments.find(e => e.serialnumber === equip.serialnumber);

          if (matchedEquip) {
            // Adiciona informações de Wi-Fi e calibração
            equip.wf = matchedEquip.wf === 'OK' ? 'Sim' : "Não";
            equip.calph = matchedEquip.calph === 'OK' ? 'Sim' : "Não";
            equip.dcal = matchedEquip.dcal;
          }

          return equip;
        });

        // Obtem informações de usuários
        const userEmails = equipmentsData.map((equip) => equip.email).filter(Boolean);

        if (userEmails.length > 0) {
          const usersResponse = await ApiMServer.post('/usersfilter', { filter: userEmails });

          const usersData = usersResponse.data;

          // Associa usuários aos equipamentos
          for (let j = 0; j < equipmentsData.length; j++) {
            equipmentsData[j].user = usersData.find((element) =>
              element.email === equipmentsData[j].email
            );
          }
        }

        // Busca informações detalhadas de equipamentos
        const equipmentResponse = await ApiGServer.post(`/equipment/filter`, { "filter": filter });

        // Mescla todos os dados
        processEquipmentData(equipmentsData, equipmentResponse.data);
      } catch (error) {
        console.error("Erro ao carregar dados:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [location]);

  const processEquipmentData = (data1, data2) => {
    // Cria um mapa para acesso rápido aos dados
    const data1Map = data1.reduce((acc, item) => {
      acc[item.serialnumber] = item;
      return acc;
    }, {});

    // Mescla os dados dos dois conjuntos
    const updatedData = data2.map((item) => {
      const correspondingData1Item = data1Map[item.serialnumber] || {};
      const filCopo = Number(item.copo);

      const copo =
        filCopo === 0
          ? 'Sem dados'
          : filCopo === 150 || filCopo > 150
            ? `Pequeno | ${filCopo}`
            : `Grande | ${filCopo}`;

      return {
        ...item,
        formatedAddr: item?.address?.formatedAddr || '',
        copo: copo || '',
        email: correspondingData1Item?.email || '',
        user: correspondingData1Item?.user,
        wf: correspondingData1Item?.wf || 'Não',
        calph: correspondingData1Item?.calph || 'Não',
        lastUnlock: correspondingData1Item?.lastUnlock,
        ...correspondingData1Item
      };
    });

    setEquipments(updatedData);
  };

  // Ordena a lista pelo número serial
  const sortBySN = () => {
    const sortedEquipments = [...equipments].sort((a, b) => {
      const numA = parseInt(a.serialnumber.split('-')[1]) || 0;
      const numB = parseInt(b.serialnumber.split('-')[1]) || 0;
      return numA - numB;
    });
    setEquipments(sortedEquipments);
  };

  // Ordena a lista por data
  const sortByDate = () => {
    const sortedEquipments = [...equipments].sort((a, b) => {
      return new Date(b.updatedAt || 0) - new Date(a.updatedAt || 0);
    });
    setEquipments(sortedEquipments);
  };

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: reportTitle
  });

  // Função auxiliar para formatar datas no padrão pt-BR
  const formatDate = (date) => {
    if (!date) return '';
    try {
      return new Date(date).toLocaleDateString('pt-BR');
    } catch {
      return '';
    }
  };

  return (
    <Page className="p-3" title={reportTitle}>
      <Header page={reportTitle} />

      {loading && <Reload />}

      {!location.state?.equipFilter && !loading && (
        <div className="alert alert-warning">
          <i className="bi bi-exclamation-triangle-fill me-2"></i>
          Para visualizar o relatório, acesse-o através da tela de cooperativas.
        </div>
      )}

      {equipments.length > 0 && (
        <>
          <div style={{ fontSize: 13 }}>
            Ordenar lista por:
          </div>

          <Card className='mb-2 mt-2 p-2'>
            <Row>
              <Col>
                <Button
                  className='ms-2 mt-2 mb-2'
                  onClick={sortBySN}
                  variant='success'
                >
                  Número Serial
                </Button>

                <Button
                  className='ms-2 mt-2 mb-2'
                  onClick={sortByDate}
                  variant='success'
                >
                  Data
                </Button>

                <Button
                  className='ms-2 mt-2 mb-2'
                  onClick={handlePrint}
                  variant="success"
                >
                  Imprimir
                </Button>

                <Download data={equipments} />
              </Col>
            </Row>
          </Card>

          <div ref={componentRef}>
            <Results data={equipments} />
          </div>
        </>
      )}
    </Page>
  );
};

export default Relatorio;
